import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaUploadComponent } from './ca-upload.component';
import { CaUploadService } from './ca-upload.service';
import { CoreModule } from '@dm/core';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    exports: [CaUploadComponent],
    declarations: [CaUploadComponent],
    providers: [CaUploadService],
})
export class CaUploadModule { }
